// extracted by mini-css-extract-plugin
export default {"productGrid":"S0-z","centerLink":"T0-z","productSection":"U0-z","item":"V0-z","ctaButton":"W0-z"};